// extracted by mini-css-extract-plugin
export default {"form":"TranslateMainPageBlockForm_form__kZ+Lh","rich-text-description":"TranslateMainPageBlockForm_rich-text-description__7QhH+"};